module.exports = __webpack_public_path__ + "img/karasz_nori.55a7a196.jpg";